const transatelDataRecharge = {
  product: {
    label: "Produit correspondant"
  },
  transatelPreviousThreshold: {
    label: "Palier précedent"
  },
  transatelNextThreshold: {
    label: "Palier suivant"
  }
};

export default transatelDataRecharge;
